export default __webpack_public_path__ + "static/media/plane.e08b5be3.ogg";